module.exports = __webpack_public_path__ + "static/4628b61d.christmasToy.png";